import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import "../../scss/card.css"
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';
import { useNavigate } from 'react-router-dom';

const InstituteViewPdfBook = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const authorizedAxiosCommon = generateAxiosInstanceCommon()
    const instituteMasterId = localStorage.getItem("instituteMasterId")

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        instituteSyllabusStructureMasterId: '',
        instituteSubjectMasterId: '',
        instituteLessonMasterId: '',
        instituteTopicMasterId: '',
        instituteSubTopicId: '',
        instituteSubTopicName: '',
        details: ''
    }
    const [syllabusList, setSyllabusList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [subTopicViewtopicList, setSubTopicViewtopicList] = useState([])
    const [subtopicList, setSubtopicList] = useState([])
    const [subtopicData, setSubtopicData] = useState(initialFormState)
    const [subjectList, setSubjectList] = useState([])
    const [filterbook, setFilterBook] = useState()
    const [syType, setSyType] = useState("")
    const [currentIndex, setCurrentIndex] = useState(0);
    const navigate = useNavigate()
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (subtopicData.instituteSubjectMasterId !== '') {
            let apiUrl = '';

            const apiUrls = {
                I: `/get-institute-sub-topic-master?` +
                    `instituteMasterId=${instituteMasterId}&` +
                    (subtopicData.instituteSyllabusStructureMasterId ? `instituteSyllabusStructureMasterId=${subtopicData.instituteSyllabusStructureMasterId}&` : '') +
                    (subtopicData.instituteSubjectMasterId ? `instituteSubjectMasterId=${subtopicData.instituteSubjectMasterId}&` : '') +
                    (subtopicData.instituteLessonMasterId ? `instituteLessonMasterId=${subtopicData.instituteLessonMasterId}&` : '') +
                    (subtopicData.instituteTopicMasterId ? `instituteTopicMasterId=${subtopicData.instituteTopicMasterId}&` : '') +
                    (subtopicData.instituteSubTopicId ? `instituteSubTopicId=${subtopicData.instituteSubTopicId}&` : ''),
                A: `/get-sub-topic-master-list?` +
                    (subtopicData.instituteSyllabusStructureMasterId ? `syllabusStructureId=${subtopicData.instituteSyllabusStructureMasterId}&` : '') +
                    (subtopicData.instituteSubjectMasterId ? `subjectMasterId=${subtopicData.instituteSubjectMasterId}&` : '') +
                    (subtopicData.instituteLessonMasterId ? `lessonId=${subtopicData.instituteLessonMasterId}&` : '') +
                    (subtopicData.instituteTopicMasterId ? `topicId=${subtopicData.instituteTopicMasterId}&` : '') +
                    (subtopicData.instituteSubTopicId ? `subTopicId=${subtopicData.instituteSubTopicId}&` : ''),
            };

            // Retrieve the API URL based on the syType
            apiUrl = apiUrls[syType];

            // Remove trailing '&' if it exists
            apiUrl = apiUrl.replace(/&$/, '');

            // Use the appropriate Axios instance
            const axiosInstances = {
                I: authorizedAxiosInstitute,
                A: authorizedAxios
            };

            const axiosInstance = axiosInstances[syType];

            axiosInstance && axiosInstance.get(apiUrl)
                .then(response => {
                    setSubtopicList(response.data.result);
                })
                .catch(error => {
                    setSubtopicList([]);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }, [subtopicData]);

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-all-syllabus-structure?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [name]: value
            }
        })
    }

    const handleSyllabusChange = (e) => {
        const { name, value } = e.target; // Destructure name and value from e.target
        const id = value.slice(0, -1); // Get the ID by removing the last character
        const type = value.slice(-1); // Get the type (last character)

        // Reset states
        setFilterBook();
        setSyType(type);
        setSubjectList([]);
        setLessonList([]);
        setTopicList([]);
        setSubtopicList([]);

        // Update subtopic data state
        setSubtopicData((prevData) => ({
            ...prevData,
            [name]: id, // Use destructured name
            instituteLessonMasterId: '',
            instituteTopicMasterId: '',
            instituteSubTopicId: '',
            instituteSubjectMasterId: ''
        }));

        // Define axios instances and API URLs
        const axiosInstances = {
            I: authorizedAxiosInstitute,
            A: authorizedAxios
        };

        const apiUrls = {
            I: `/get-institute-syllabus-structure-Wise-institute-subjects?id=${id}`,
            A: `/syllabus-structure-wise-subjects?id=${id}`
        };

        // Fetch subjects based on type
        const axiosInstance = axiosInstances[type];
        const apiUrl = apiUrls[type];

        if (axiosInstance) {
            axiosInstance.get(apiUrl)
                .then(response => {
                    setSubjectList(response.data.result); // Set subject list from API response
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    };


    const handleSubjectChange = (e) => {
        const { name, value } = e.target;

        // Update subtopic data state
        setSubtopicData((prevData) => ({
            ...prevData,
            [name]: value,
            instituteLessonMasterId: '',
            instituteTopicMasterId: '',
            instituteSubTopicId: '',
        }));

        // Define axios instances and API URLs
        const axiosInstances = {
            I: authorizedAxiosInstitute,
            A: authorizedAxios
        };

        const apiUrls = {
            I: `/get-institute-subject-wise-institute-lesson?instituteMasterId=${instituteMasterId}&instituteSyllabusStructureMasterId=${subtopicData.instituteSyllabusStructureMasterId}&instituteSubjectMasterId=${value}`,
            A: `/subject-wise-lesson?syllabusStructureMasterId=${subtopicData.instituteSyllabusStructureMasterId}&subjectMasterId=${value}`
        };

        // Get the appropriate axios instance and API URL based on `syType`
        const axiosInstance = axiosInstances[syType];
        const apiUrl = apiUrls[syType];

        // Fetch lessons if axiosInstance is valid
        if (axiosInstance) {
            axiosInstance.get(apiUrl)
                .then(response => {
                    setLessonList(response.data.result); // Set lesson list from API response
                    setFilterBook(0); // Reset filterBook
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    };


    const handleLessonChange = (e) => {
        const { name, value } = e.target;

        // Update subtopic data state
        setSubtopicData((prevData) => ({
            ...prevData,
            [name]: value,
            instituteTopicMasterId: '',
            instituteSubTopicId: ''
        }));

        // Define axios instances and API URLs
        const axiosInstances = {
            I: authorizedAxiosInstitute,
            A: authorizedAxios
        };

        const apiUrls = {
            I: `/get-institute-lesson-wise-institute-sub-topic?id=${value}`,
            A: `/lesson-wise-topic?id=${value}`
        };

        // Get the appropriate axios instance and API URL based on `syType`
        const axiosInstance = axiosInstances[syType];
        const apiUrl = apiUrls[syType];

        // Fetch topics if axiosInstance is valid
        if (axiosInstance) {
            axiosInstance.get(apiUrl)
                .then(response => {
                    setTopicList(response.data.result); // Set topic list from API response
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    };


    const handleTopicChange = (e) => {
        const { name, value } = e.target;

        // Update subtopic data state
        setSubtopicData((prevData) => ({
            ...prevData,
            [name]: value,
            instituteSubTopicId: ''
        }));

        // Define axios instances and API URLs
        const axiosInstances = {
            I: authorizedAxiosInstitute,
            A: authorizedAxios
        };

        const apiUrls = {
            I: `/get-institute-sub-topic-master?instituteMasterId=${instituteMasterId}&instituteSyllabusStructureMasterId=${subtopicData.instituteSyllabusStructureMasterId}&instituteSubjectMasterId=${subtopicData.instituteSubjectMasterId}&instituteLessonMasterId=${subtopicData.instituteLessonMasterId}&instituteTopicMasterId=${value}`,
            A: `/get-sub-topic-master-list?syllabusStructureId=${subtopicData.instituteSyllabusStructureMasterId}&subjectMasterId=${subtopicData.instituteSubjectMasterId}&lessonId=${subtopicData.instituteLessonMasterId}&topicId=${value}`
        };

        // Get the appropriate axios instance and API URL based on `syType`
        const axiosInstance = axiosInstances[syType];
        const apiUrl = apiUrls[syType];

        // Fetch subtopics if axiosInstance is valid
        if (axiosInstance) {
            axiosInstance.get(apiUrl)
                .then(response => {
                    setSubTopicViewtopicList(response.data.result); // Set subtopic list from API response
                })
                .catch(error => {
                    setSubTopicViewtopicList([]); // Reset subtopic view if an error occurs
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    };


    const handleNext = () => {
        if (currentIndex < subtopicList.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    useEffect(() => {
        setCurrentIndex(0)
    }, [subtopicData])

    const generatePDF = () => {
        let apiUrl = window.location.origin;

        if (subtopicData.instituteSyllabusStructureMasterId) {
            apiUrl += `/print?syType=${syType}&SyllabusStructureMasterId=${subtopicData.instituteSyllabusStructureMasterId}&`;
        }
        if (subtopicData.instituteSubjectMasterId) {
            apiUrl += `SubjectMasterId=${subtopicData.instituteSubjectMasterId}&`
        }
        if (subtopicData.instituteMasterId) {
            apiUrl += `instituteMasterId=${instituteMasterId}&`;
        }
        if (subtopicData.instituteLessonMasterId) {
            apiUrl += `LessonMasterId=${subtopicData.instituteLessonMasterId}&`;
        }
        if (subtopicData.instituteTopicMasterId) {
            apiUrl += `TopicMasterId=${subtopicData.instituteTopicMasterId}&`;
        }
        if (subtopicData.instituteSubTopicId) {
            apiUrl += `SubTopicId=${subtopicData.instituteSubTopicId}&`;
        }
        apiUrl = apiUrl.replace(/&$/, '');
        window.open(apiUrl, "_blank");
    };

    return (
        <>
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>View Content Book</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-eye"></i> View Content Book</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteSyllabusStructureMasterId' onChange={handleSyllabusChange} value={subtopicData.instituteSyllabusStructureMasterId + syType}>
                                                        <option selected value={''} disabled>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option style={{ color: syllabus.type == "I" ? "blue" : syllabus.type == "B" ? "red" : '' }} value={syllabus.id + syllabus.type} >{syllabus?.syllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label htmlFor="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select required className="form-select" aria-label="Default select example" name='instituteSubjectMasterId' onChange={handleSubjectChange} value={subtopicData?.instituteSubjectMasterId} >
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option key={syllabus?.id} value={syType === "I" ? syllabus?.instituteSubjectMasterDetails?.id : syllabus?.subjectMasterDetails?.id}>
                                                                    {syType === "I" ? syllabus?.instituteSubjectMasterDetails?.subjectName : syllabus?.subjectMasterDetails?.subjectName}
                                                                </option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label htmlFor="inputPassword" className="col-form-label">Select Lesson :</label>
                                                    <select required className="form-select" aria-label="Default select example" name='instituteLessonMasterId' onChange={handleLessonChange} value={subtopicData.instituteLessonMasterId} >
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option key={lesson?.id} value={lesson?.id}>
                                                                    {syType === "I" ? lesson?.instituteLessonName : lesson?.lessonName}
                                                                </option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label htmlFor="inputPassword" className="col-form-label">Select Topic :</label>
                                                    <select required className="form-select" aria-label="Default select example" name='instituteTopicMasterId' onChange={handleTopicChange} value={subtopicData.instituteTopicMasterId} >
                                                        <option selected value={''} disabled>Select Topic</option>
                                                        {
                                                            topicList?.map((topic) => {
                                                                return <option key={topic?.id} value={topic?.id}>
                                                                    {syType === "I" ? topic?.instituteTopicName : topic?.topicName}
                                                                </option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label htmlFor="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                                    <select required className="form-select" aria-label="Default select example" name='instituteSubTopicId' onChange={handleInputChange} value={subtopicData.instituteSubTopicId} >
                                                        <option selected value={''} disabled>Select Sub Topic</option>
                                                        {
                                                            subTopicViewtopicList?.map((topic) => {
                                                                return <option key={topic?.id} value={topic?.id}>
                                                                    {syType === "I" ? topic?.instituteSubTopicName : topic?.subTopicName}
                                                                </option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                            </div>

                                            <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => { setSubtopicData(initialFormState); setFilterBook(0); setSubtopicList([]); setFilterBook(); setSyType('') }}>Reset</button>
                                            </div>

                                            {subtopicData.instituteSyllabusStructureMasterId.length !== 0 && subtopicData.instituteSubjectMasterId.length !== 0 && (
                                                <div className="content_book_wraper">
                                                    {subtopicList.length !== 0 && (
                                                        <h4 className="text-blue" onClick={() => generatePDF(subtopicList)}>
                                                            <b>
                                                                <span className="fa fa-file-o"></span>
                                                                <button className='print-btn btn btn-info'>Print<i className="fa fa-print"></i></button>
                                                            </b>
                                                        </h4>
                                                    )}
                                                    <div className="content_book_wrap">
                                                        <div className="row">
                                                            <div className="book">
                                                                <div className='lesson_area'>
                                                                    <div className='lesson_no'>
                                                                        <div className='info'>
                                                                            <span className='capt'>Class:</span>
                                                                            <span className='value'>
                                                                                {syType === "I"
                                                                                    ? subtopicList[currentIndex]?.instituteSyllabusStructureMasterDetails?.instituteGradeMasterDetails?.gradeName
                                                                                    : subtopicList[currentIndex]?.subTopicMasterSyllabusStructureMasterDetails?.gradeMasterDetails?.gradeName}
                                                                            </span>
                                                                        </div>
                                                                        <div className='info'>
                                                                            <span className='capt'>Subject:</span>
                                                                            <span className='value'>
                                                                                {syType === "I"
                                                                                    ? subtopicList[currentIndex]?.instituteSubjectMasterDetails?.subjectName
                                                                                    : subtopicList[currentIndex]?.subjectMasterDetails?.subjectName}
                                                                            </span>
                                                                        </div>
                                                                    </div>

                                                                    <div className='chapter_name'>
                                                                        <div className='info'>
                                                                            <span className='capt'>Chapter Name: </span>
                                                                            <span className='value'>
                                                                                {syType === "I"
                                                                                    ? subtopicList[currentIndex]?.instituteLessonMasterDetails?.instituteLessonName
                                                                                    : subtopicList[currentIndex]?.subTopicMasterLessonMasterDetails?.lessonName}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="page">
                                                                    {subtopicList[currentIndex]?.details ? (
                                                                        <div
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">${subtopicList[currentIndex].details}</div>`
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <p style={{
                                                                            textAlign: "center",
                                                                            fontSize: "1rem",
                                                                            color: "#333",
                                                                            fontStyle: "italic",
                                                                            margin: "20px 0",
                                                                            padding: "10px",
                                                                            backgroundColor: "#f0f0f0",
                                                                            borderRadius: "4px",
                                                                            border: "1px solid #ccc",
                                                                        }}>
                                                                            No content available.
                                                                        </p>
                                                                    )}
                                                                </div>

                                                                <div className='nav_btn_progress'>
                                                                    <button className="btn btn-outline-danger view_icon" type="button" style={{ marginRight: '0' }} disabled={currentIndex === 0} onClick={() => { handlePrev() }}>
                                                                        <i className="fa fa-chevron-left"></i>
                                                                    </button>

                                                                    <div className="progress_bar_block">
                                                                        <span className='read_progress' style={{ width: `${((currentIndex + 1) / subtopicList.length) * 100}%` }}></span>
                                                                    </div>

                                                                    <button className="btn btn-outline-danger view_icon" type="button" style={{ marginRight: '0' }} disabled={currentIndex === subtopicList.length - 1} onClick={() => { handleNext() }}>
                                                                        <i className="fa fa-chevron-right"></i>
                                                                    </button>
                                                                </div>

                                                                <div className='page_no_area'>
                                                                    <div className='page_no'>
                                                                        <span>{currentIndex + 1} of {subtopicList.length}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}



                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteViewPdfBook;